//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
// const querystring = require('querystring');
export default class Desktops extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
		// JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
		this.state = {
			location : 		JSON.parse(parms).location,
			desktops : [
			]
		}
		this.props = props;
		this.deleteDesktop = this.deleteDesktop;
	}
	
	componentDidMount() {
		let self = this;
		//console.log(self.state.currentUserIdentity.id);
        var queryUrl = `${global.config.apiServicesUrl}/desktop?filter[where][createUser][eq]=${this.props.userId}`;
        console.log(queryUrl);
        fetch(queryUrl, {
            method: 'GET'
        }).then(function(response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }
            return response.json();
        }).then(function(data) {
            self.setState({desktops: data});
            console.log(data);
        }).catch(err => {
        console.log('caught an exception!',err);
        })
	}

	deleteDesktop(desktopId)
	{
        var queryUrl = `${global.config.apiServicesUrl}/desktop/${this.props.userId}`; 
//         console.log(queryUrl);
//         fetch(queryUrl, {
//             method: 'DELETE'
//         }).then(function(response) {
//             if (response.status >= 400) {
//                 throw new Error("Bad response from server");
//             }
//             return response.json();
//         }).then(function(data) {
//             //self.setState({desktops: data});
//             console.log(data);
//         }).catch(err => {
//         console.log('caught an exception!',err);
//         })
	}
	
    render(){

        return (
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
					<div class="m-content">
						<div class="m-portlet m-portlet--mobile">
							<div class="m-portlet__head">
								<div class="m-portlet__head-caption">
									<div class="m-portlet__head-title">
										<Link to="/desktops/">
										<h3 class="m-portlet__head-text">
											My Virtual Desktops
										</h3>
										</Link>
									</div>
								</div>
								<div class="m-portlet__head-tools">
									<ul class="m-portlet__nav">
										<li class="m-portlet__nav-item">
											<Link to="/create-desktop" class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air">
												<span>
													<i class="la la-plus"></i>
													<span>New Desktop</span>
												</span>
											</Link>
										</li>

									</ul>
								</div>
							</div>
							
							<div className="content-wrapper">
								<div class="m-portlet">
     							<div class="m-portlet__body">
									<iframe src={this.state.location } style={{display:'block', width:'80vw', height:"60vh"}}/>
								</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}